// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","161":"4149653a","371":"6fc3fa19","995":"b2aa14dc"}[chunkId] + ".js";
};